export default Object.freeze({
    UNDER_25K: 'under-25K',
    UNDER_100K: '25-100K',
    UNDER_250K: '100-250K',
    UNDER_500K: '250-500K',
    UNDER_1M: '500K-1M',
    OVER_1M: '1M+',
    NOT_SURE: 'not-sure',
});
